import scope from "@/constants/Scope";

const settings = {
    categoryName: "version",
    scope: scope,
  } as const;

  export default settings;